import {Component, Host, h, State, Event, EventEmitter} from '@stencil/core';

@Component({
  tag: 'nest-shell-panel',
  styleUrl: 'nest-shell-panel.scss',
  shadow: true,
})
export class NestShellPanel {
  @State() expanded: boolean;

  @Event() nestPanelExpanded: EventEmitter<boolean>;

  setExpanded = () => {
    this.expanded = !this.expanded;
    this.nestPanelExpanded.emit(this.expanded);
    // localStorage.setItem('shell_panel_expanded', JSON.stringify(this.expanded));
  }

  componentWillLoad() {
    // this.expanded = JSON.parse(localStorage.getItem('shell_panel_expanded') || 'false') || false;
  }

  render() {
    const {expanded} = this;


    return (
      <Host>
        <aside class={{
          'fixed h-screen z-20 bg-white border-r w-16': true,
          'w-fit': expanded
        }}>
          <div
            class="absolute flex items-center justify-center border hover:cursor-pointer p-1.5 rounded-full -right-3.5 bg-white top-2"
            onClick={this.setExpanded}
          >
            <nest-icon name={this.expanded ? 'chevron-left': 'chevron-right'} class='w-4 h-4' />
          </div>
          <div class="flex flex-col bg-background min-h-[calc(100vh-theme(spacing.16))]">
            <div class="flex-1 px-3 mt-5">
              <slot name='panel-start'/>
            </div>
            <div class="mb-2 px-3 mt-4">
              <slot name='panel-end'/>
            </div>

            <div class="border-t flex p-3">
              <img src="https://ui-avatars.com/api/?background=c7d2fe&color=3730a3&bold=true&name=n" class="w-10 h-10 rounded" alt="" />
              <div
                class={`flex justify-between items-center overflow-hidden transition-all ${expanded ? "w-52 ml-3" : "w-0"}`}>
                <div class="leading-4">
                  <h4 class="font-semibold">Administrator</h4>
                  <span class="text-xs text-gray-600">admin@admin.com</span>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </Host>
    );
  }
}
